import React from 'react';
import {
  Package,
  PackageCheck,
  MapPin,
  CheckCircle2,
  XCircle,
  Circle,
  CalendarCheck,
  Box,
} from 'lucide-react';
import { getIconProps, IconProps } from '../../utils';
import { OrderUnifiedStatus } from '@hero/api';
import { VehicleMainIcon } from '../Vehicle';
import CorrectSvg from '../../assets/order/correct.svg?react';
import LoadItemsSvg from '../../assets/order/package.svg?react';
import ItemsdownSvg from '../../assets/order/packdown.svg?react';

/** New order status icon */
export const OrderStatusNewIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Box {...iconProps} />;
};

/** Accepted order status icon */
export const OrderStatusAcceptedIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  //return <Package {...iconProps} />;
  return <Circle {...iconProps} />;
};

/** Published order status icon */
export const OrderStatusPublishedIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Package {...iconProps} />;
};

/** Confirmed order status icon */
export const OrderStatusConfirmedIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <CorrectSvg {...iconProps} />;
};

/** In transit to pickup status icon */
export const OrderStatusInTransitIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <VehicleMainIcon {...iconProps} />;
};

/** Arrived at pickup status icon */
export const OrderStatusArrivedPickupIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <LoadItemsSvg {...iconProps} />;
};

/** Arrived at dropoff status icon */
export const OrderStatusArrivedDropoffIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <ItemsdownSvg {...iconProps} />;
};

/** Delivered order status icon */
export const OrderStatusDeliveredIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <PackageCheck {...iconProps} />;
};

/** Canceled order status icon */
export const OrderStatusCanceledIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <XCircle {...iconProps} />;
};

/** Active after confirmed status icon */
export const OrderStatusActiveIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <VehicleMainIcon {...iconProps} />;
};

/** Verified orders status icon */
export const OrderStatusVerifiedOrdersIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <CheckCircle2 {...iconProps} />;
};

/** Unverified orders status icon */
export const OrderStatusUnverifiedOrdersIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Circle {...iconProps} />;
};

/**
 * Dynamic order status icon component
 * Takes an OrderUnifiedStatus and returns the appropriate icon
 */
export const OrderStatusDynamicIcon: React.FC<
  IconProps & { status: OrderUnifiedStatus }
> = props => {
  const { status, ...rest } = props;

  switch (status) {
    case 'new':
      return <OrderStatusNewIcon {...rest} />;
    case 'accepted':
      return <OrderStatusAcceptedIcon {...rest} />;
    case 'published':
      return <OrderStatusPublishedIcon {...rest} />;
    case 'confirmed':
      return <OrderStatusConfirmedIcon {...rest} />;
    case 'in_transit_pickup':
      return <OrderStatusInTransitIcon {...rest} />;
    case 'arrived_pickup':
      return <OrderStatusArrivedPickupIcon {...rest} />;
    case 'in_transit_dropoff':
      return <OrderStatusInTransitIcon {...rest} />;
    case 'arrived_dropoff':
      return <OrderStatusArrivedDropoffIcon {...rest} />;
    case 'delivered':
      return <OrderStatusDeliveredIcon {...rest} />;
    case 'canceled':
      return <OrderStatusCanceledIcon {...rest} />;
    case 'any_active_status':
      return <OrderStatusActiveIcon {...rest} />;
    case 'active_after_confirmed':
      return <OrderStatusActiveIcon {...rest} />;
    case 'verified_orders':
      return <OrderStatusVerifiedOrdersIcon {...rest} />;
    case 'unverified_orders':
      return <OrderStatusUnverifiedOrdersIcon {...rest} />;
    default:
      return <OrderStatusNewIcon {...rest} />;
  }
};
